import {SagaIterator} from 'redux-saga';
import {call, cancel, put, putResolve, select, takeEvery} from 'redux-saga/effects';

import {STEPS} from 'desktop/pages/checkout/constants/checkout';
import {apiConfig} from 'libs/api/api';
import {ActionType} from 'types/reducers';

import {placeOrder} from '../../actions/completeOrder/completeOrder';
import {setCheckoutStep} from '../../reducers/currentStep/currentStep';
import {getPaymentMethods as getPaymentMethodsReducer} from '../../reducers/paymentStep/paymentMethods/paymentMethods';
import {routerInfoUpdated} from '../../reducers/sagaStep/sagaStep';
import {changeStepStatus} from '../../reducers/status/status';
import {getCurrentStep} from '../../selectors/currentStep/currentStep';

import {amazonAuth} from './paymentMethods/amazon/amazon/amazonV2';
import {beforeInitialAmazon} from './paymentMethods/paymentMethods';

import {onPlaceOrderSaga} from './placeOrder';

/**
 *  Set loaded status payment step
 * @param {boolean} isLoaded - is loaded payment step
 */
export function* setLoadedPaymentStep(isLoaded = true): SagaIterator {
    yield put(
        changeStepStatus({
            [STEPS.PAYMENT_STEP]: {
                loaded: isLoaded,
            },
        }),
    );
}

/**
 * Get payment methods
 */
export function* getPaymentMethodsSaga(): SagaIterator {
    const getMethodsAction = yield call(getPaymentMethodsReducer);
    yield putResolve(getMethodsAction);
}

/**
 * Start payment step saga
 */
export function* startPaymentStepSaga(): SagaIterator {
    yield call(amazonAuth);
    const {routerInfo} = apiConfig.hostStore.getState();
    const currentStep = yield select(getCurrentStep);

    if (
        !['paypal', 'checkout'].includes(routerInfo.module) ||
        routerInfo.controller === 'cart' ||
        routerInfo.action === 'success'
    ) {
        yield cancel();
    }

    if (currentStep === STEPS.PAYMENT_STEP) yield call(getPaymentMethodsSaga);

    yield call(beforeInitialAmazon);
}

/**
 * Prepared payment step
 */
export function* preparePaymentStep(): SagaIterator {
    // get payment methods
    yield call(getPaymentMethodsSaga);
    // check ready current step
    yield call(setLoadedPaymentStep);
}

/**
 * After change active step calls need actions\methods
 */
export function* afterSetActiveStep({payload}: ActionType<string>): SagaIterator {
    if (payload === STEPS.PAYMENT_STEP) yield call(preparePaymentStep);
}

/**
 * Begin of saga
 */
export function* paymentStepSaga(): SagaIterator {
    yield takeEvery(`${routerInfoUpdated}`, startPaymentStepSaga);
    yield takeEvery(`${getPaymentMethodsReducer.fulfilled}`, beforeInitialAmazon);
    yield takeEvery(`${setCheckoutStep}`, afterSetActiveStep);
    yield takeEvery(`${placeOrder}`, onPlaceOrderSaga);
}
